{
    "firstName": "Eduard",
    "lastName": "Jančík",
    "dateOfBirth": "1957-04-28",
    "identityCard": {
        "typeName": null,
        "type": null,
        "value": null,
        "validFrom": null,
        "validTo": null,
        "issuedBy": null
    },
    "email": "ekptest190@allianz.sk",
    "mobile": "+420903473106",
    "idNumber": "EDJA6364",
    "address": {
        "street": "Podhradie",
        "houseNumber": "505",
        "houseOrientationNumber": "1",
        "zip": "90901",
        "city": "Skalica",
        "country": {
            "continentCode": "EU",
            "enCountryName": "Slovakia",
            "note": "",
            "skCountryName": "Slovenská republika",
            "threeLetterCountryCode": "SVK",
            "twoLetterCountryCode": "SK"
        }
    },
    "personalNumber": "5704287721",
    "passwordLastChange": "2025-02-24T14:14:38.48+01:00",
    "mailService": {
        "typeId": 1,
        "typeLabel": "Všetky PZ",
        "email": "mail@devel.com",
        "phoneNumber": "+421900900902",
        "password": "HesloEK"
    },
    "partId": "1234",
    "changeRequestOpened": false,
    "shouldUnifyContacts": false,
    "maidenName": "",
    "title": ""
}